import config from '../../config';
import FetchHelper from './OldFetchHelper';

class OldStatisticsHelper {
  uplines = {};

  async fetchCustomerStatistics() {
    const fetchConfig = {
      path: `${config.api.paths.statistics.basepath}${config.api.paths.statistics.paths.members.basepath}${config.api.paths.statistics.paths.members.paths.customer}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async fetchRevenueStatistics() {
    const fetchConfig = {
      path: `${config.api.paths.statistics.basepath}${config.api.paths.statistics.paths.revenue.basepath}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async fetchTeamStatistics() {
    const fetchConfig = {
      path: `${config.api.paths.statistics.basepath}${config.api.paths.statistics.paths.members.basepath}${config.api.paths.statistics.paths.members.paths.team.basepath}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async fetchTeamRevenueStatistics() {
    const fetchConfig = {
      path: `${config.api.paths.statistics.basepath}${config.api.paths.statistics.paths.revenue.basepath}${config.api.paths.statistics.paths.revenue.paths.team}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async fetchTeamCustomerStatistics() {
    const fetchConfig = {
      path: `${config.api.paths.statistics.basepath}${config.api.paths.statistics.paths.members.basepath}${config.api.paths.statistics.paths.members.paths.team.basepath}${config.api.paths.statistics.paths.members.paths.team.paths.customer}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  getFiltersFetchConfig(filters) {
    let ret = [];

    for(const filter of Object.keys(filters)) {
      if(Object.prototype.hasOwnProperty.call(filters, filter) && filters[filter]) {
        ret = [...ret, `${filter}=${filters[filter]}`];
      }
    }

    return ret.length > 0 ? `/?${ret.join(`&`)}` : ``;
  }

  async getGenerations(filters) {
    const path = `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.generations}`;
    return this.fetchStatisticsData(path, filters);
  }

  async getInvoicingPoints(id) {
    const fetchConfig = {
      path: `${config.api.paths.partnershop.basepath}${config.api.paths.partnershop.paths.invoicingPoints}/${id}`,
    };

    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async getInvoicingNumbers(format) {
    const query = format ? `?dateFormat=${format}` : ``;
    const fetchConfig = {
      path: `${config.api.paths.customers.basepath}${config.api.paths.customers.paths.invoicingIds}${query}`,
    };
    const fetchResult = await FetchHelper.get(fetchConfig);

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async getTeamGrowth(filter) {
    const filters = filter ? this.getFiltersFetchConfig(filter) : ``;
    const fetchResult = await FetchHelper.get({
      path: `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.teamGrowth}${filters}`,
    });
    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }
    return fetchResult.data;
  }

  async getTeamInactivePartners(filter) {
    const filters = filter ? this.getFiltersFetchConfig(filter) : ``;
    const fetchResult = await FetchHelper.get({
      path: `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.inactivePartners}${filters}`,
    });
    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }
    return fetchResult.data;
  }

  async getTeamNewVendorVolume(filter) {
    const filters = filter ? this.getFiltersFetchConfig(filter) : ``;
    const fetchResult = await FetchHelper.get({
      path: `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.newVendorVolume}${filters}`,
    });
    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }
    return fetchResult.data;
  }

  async getTeamNewlyReachedTargetLevels(filter) {
    const filters = filter ? this.getFiltersFetchConfig(filter) : ``;
    const fetchResult = await FetchHelper.get({
      path: `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.newTargetLevels}${filters}`,
    });
    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async getTeamRankings(filter) {
    const filters = filter ? this.getFiltersFetchConfig(filter) : ``;
    const fetchResult = await FetchHelper.get({
      path: `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.rankings}${filters}`,
    });
    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return fetchResult.data;
  }

  async getNewPartners(filter) {
    const filters = filter ? this.getFiltersFetchConfig(filter) : ``;
    const path = `${config.api.paths.partnershop.basepath}${config.api.paths.partnershop.paths.new}${filters}`;
    const fetchResult = await FetchHelper.get({ path });
    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }
    return {
      count: fetchResult.count,
      data: fetchResult.data,
    };
  }

  async getRevenueQuery(filters) {
    const path = `${config.api.paths.partnershop.basepath}${config.api.paths.partnershop.paths.revenueQuery}`;
    return this.fetchStatisticsData(path, filters);
  }

  async getRevenueQueryTeam(filters) {
    const path = `${config.api.paths.teams.basepath}${config.api.paths.teams.paths.revenueQuery}`;
    return this.fetchStatisticsData(path, filters);
  }

  async fetchStatisticsData(path, filters) {
    const internalFilters = filters ? this.getFiltersFetchConfig(filters) : ``;
    const fetchResult = await FetchHelper.get({ path: `${path}${internalFilters}` });

    if(!fetchResult.success) {
      throw new Error(fetchResult.message);
    }

    return {
      count: fetchResult.count,
      data: fetchResult.data,
    };
  }

  async getUpline(customerNumber) {
    if(!this.uplines[customerNumber]) {
      const params = this.getFiltersFetchConfig({ customerNumber });
      const path = `${config.api.paths.partnershop.basepath}${config.api.paths.partnershop.paths.upline}${params}`;
      const fetchResult = await FetchHelper.get({ path });
      if(fetchResult.success) {
        this.uplines[customerNumber] = fetchResult.data;
      }
    }
    return this.uplines[customerNumber];
  }

  async fetchFairscore(filters) {
    const internalFilters = filters ? this.getFiltersFetchConfig(filters) : ``;
    const path = `${config.api.paths.partnershop.basepath}${config.api.paths.partnershop.paths.fairScore}${internalFilters}`;
    const fetchResult = await FetchHelper.get({ path });
    if(!fetchResult.success) {
      return false;
    }
    return fetchResult.data;
  }
}

export default new OldStatisticsHelper();
